<p>admin login works!</p>


<body
   class="vertical-layout vertical-menu-modern 1-column  navbar-floating footer-static bg-full-screen-image  blank-page blank-page"
   data-open="click" data-menu="vertical-menu-modern" data-col="1-column">

   <!-- BEGIN: Content-->
   <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
         <div class="content-header row">
         </div>
         <div class="content-body" style="margin-left:0px;">
            <section class="row flexbox-container">
               <div class="col-xl-12 col-12 d-flex justify-content-center">
                  <div class="card bg-authentication rounded-0 mb-0">
                     <div class="row m-0">
                        <div class="col-lg-12 col-12 p-0">
                           <div class="card rounded-0 mb-0 px-2">
                              <div class="card-header pb-1">
                                 <div class="card-title">
                                    <h4 class="mb-0">Admin Login</h4>
                                 </div>
                              </div>
                              <p class="px-2">Welcome back, please login to your account.</p>
                              <div class="card-content">
                                 <div class="card-body pt-1">
                                    <div class="text-center" id="loginErrMsg"
                                       style="display:none; color: red;padding:0 0 20px 0;"></div>

                                    <form [formGroup]="loginForm" class="login-container" (ngSubmit)="onSubmitAdmin()">
                                       <fieldset class="form-label-group form-group position-relative has-icon-left">
                                          <label for="user-name">Username</label>
                                          <input type="text" placeholder="Username" formControlName="email"
                                             class="form-control"
                                             [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                                          <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                             <div *ngIf="f.email.errors.required">Email is required</div>
                                             <div *ngIf="f.email.errors.pattern">Please provide a valid email address
                                             </div>
                                          </div>
                                       </fieldset>
                                       <fieldset class="form-label-group position-relative has-icon-left">
                                          <label for="user-password">Password</label>
                                          <input type="password" placeholder="Password" formControlName="password"
                                             class="form-control"
                                             [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                                          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                             <div *ngIf="f.password.errors.required">Password is required</div>
                                          </div>
                                       </fieldset>

                                       <div class="form-group d-flex justify-content-between align-items-center">
                                          <div class="text-left">
                                             <fieldset class="checkbox">
                                                <div class="vs-checkbox-con vs-checkbox-primary">
                                                   <input type="checkbox" class="form-control" formControlName="rememberMe"/>
                                                   <span class="vs-checkbox">
                                                      <span class="vs-checkbox--check">
                                                         <i class="vs-icon feather icon-check"></i>
                                                      </span>
                                                   </span>
                                                   <span class="">Remember me</span>
                                                </div>
                                             </fieldset>
                                          </div>
                                          <div class="text-right"><a href="/forgotpassword"
                                                class="card-link">Forgot
                                                Password?</a></div>
                                       </div>
                                       <!-- <a href="auth-register.html" class="btn btn-outline-primary float-left btn-inline">Register</a> -->
                                       <!-- <button type="submit" class="btn btn-primary float-right btn-inline">Login</button> -->
                                       <div class="text-center">
                                          <button class="btn btn-primary btn-inline">Login</button>
                                       </div>

                                    </form>
                                 </div>
                              </div>
                              <div class="login-footer">
                                 <div class="divider">
                                    <!-- <div class="divider-text">OR</div> -->
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </section>
         </div>
      </div>
   </div>
   <!-- END: Content-->
</body>